/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Contactcodes1Inputs */

const en_nav_contactcodes1 = /** @type {(inputs: Nav_Contactcodes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Codes`)
};

const de_nav_contactcodes1 = /** @type {(inputs: Nav_Contactcodes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Codes`)
};

/**
* | output |
* | --- |
* | "Contact Codes" |
*
* @param {Nav_Contactcodes1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nav_contactcodes1 = /** @type {((inputs?: Nav_Contactcodes1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Contactcodes1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_contactcodes1(inputs)
	return de_nav_contactcodes1(inputs)
});
export { nav_contactcodes1 as "nav_contactCodes" }